import { api } from "./api";
import type { VenueSession, AllowedMethod } from "../store/types";

const VENUE_SESSION_TTL_MS = 30 * 60 * 1000; // 30 minutes

export interface VenueResponse {
  venue_id: string;
  name: string;
  allowed_methods: string[];
  show_no_tip: boolean;
  show_custom_tip: boolean;
  tip_percentages: number[];
}

export async function validateVenue(
  venueId: string,
): Promise<VenueSession> {
  // API returns 404 if venue not found/inactive
  const response = await api.get<VenueResponse>(`venues/${venueId}`);

  return {
    id: response.venue_id,
    name: response.name,
    allowedMethods: response.allowed_methods as AllowedMethod[],
    showNoTip: response.show_no_tip ?? true,
    showCustomTip: response.show_custom_tip ?? true,
    tipPercentages: (Array.isArray(response.tip_percentages) && response.tip_percentages.length > 0)
      ? response.tip_percentages
      : [15, 18, 25],
    expiresAt: Date.now() + VENUE_SESSION_TTL_MS,
  };
}
